
import { nodeHelpers } from '@/components/mixins/nodeHelpers';
import TreeWorkspace from '@/components/TreeWorkspace.vue';

import { showMessage } from '@/components/mixins/showMessage';

import Table from '@/components/Table.vue';
import FilterTable from '@/components/FilterTable.vue';
import SelectFilter from '@/components/SelectFilter.vue';
import InteractionMenu from '@/components/InteractionMenu.vue';
import RoundPhotoFrame from '@/components/RoundPhotoFrame.vue';
import BackgroundView from '@/components/BackgroundView.vue';
import AliareInput from '@/components/AliareInput.vue';
import InfoBox from '@/components/InfoBox.vue';
import AliareSelect from '@/components/AliareSelect.vue';
import WebStorage from '@/common/WebStorage';

import ModalButtonSuccess from '@/components/ModalButtonSuccess.vue';
import ModalButtonCancel from '@/components/ModalButtonCancel.vue';
import AlertNotificationModal from '@/components/AlertNotificationModal.vue';
import NotificationPage from '@/components/NotificationPage2.vue';
import Modal from '@/components/ModalAliare.vue';
import { notificationPermission } from '@/components/mixins/permissions/notifications';

import { SERVERS_SMTP_MODAL_KEY } from '../constants';

import InfoAliare from '@/components/InfoAliare.vue';
import { previousRoute } from '../router/index.ts';

import { removeItemFromArrayByValue } from '@/components/helpers';

import { VueEditor } from "vue2-editor";
import mixins from 'vue-typed-mixins';
import { mapActions } from 'vuex';
import { email } from 'vuelidate/lib/validators';



export default mixins(
	nodeHelpers,
	showMessage,
	notificationPermission,
).extend({
	components: {
		Table,
		FilterTable,
        VueEditor,
		SelectFilter,
		RoundPhotoFrame,
		InteractionMenu,
		BackgroundView,
		AliareInput,
		AliareSelect,
		AlertNotificationModal,
		ModalButtonSuccess,
		ModalButtonCancel,
		NotificationPage,
		Modal,
        InfoAliare,
		TreeWorkspace,
		InfoBox,
	},
	name: 'CreateEditNotification',
	data() {
		return {
			page: 1,
			pageSize: 10,
            form: {
                notificationName: '',
                selectedChannelNames: [],
				selectedEmails: [],
                description: '',
                contatos: [],
				results: [],
				aplicacao: [],
			},
            tempKey: '',
            channels: [
                'Email',
            ],
			emails: [],
            customToolbar: [
				["bold", "italic", "underline"],
				[{ list: "bullet" }],
				["link"],
			],
			prevSelectedWorkflows: [],
            showEmailOptions: false,
            showChannelOptions: false,
            channelSearch: '',
			emailSearch: '',
			isLoadingSecondPage: false,
			isLoadingPage: true,
			listWorkspace: {},
			messageNameError: '',
			originalNotificationName: '',
			currentStep: 'notification',
			showNotification: false,
			showAlert: false,

			messageNameSuccess: '',
			maxheight: '60vh',
		};
	},
	computed: {
        textInfoChannel() {
            return 'O envio de notificações pode gerar custos, dependendo do tipo de canal selecionado. Para obter mais informações sobre valores, entre em contato com o suporte.';
        },
        channelsFiltered() {
			if (!this.channelSearch) return this.channels;

			return this.channels.filter((channelName) =>
				channelName.toLowerCase().includes(this.channelSearch.toLowerCase()),
			);
		},
		emailsFiltered() {
			if (!this.emailSearch) return this.emails;

			return this.emails.filter((email) =>
				email.name.toLowerCase().includes(this.emailSearch.toLowerCase()),
			);
		},
		isEdit() {
			return this.$route.name === 'editNotification';
		},
		alertNotificationDescription() {
			return 'Todas as parametrizações que estão sendo feitas serão <b>excluídas</b> e você <b>não poderá recuperá-las</b>. O que você deseja fazer?';
		},

		firstPageDescriptionProfile() {
			if (this.isEdit) {
				return `A notificação <b>${ this.form.notificationName }</b> foi editada com sucesso`;
			}
			return `A notificação <b>${ this.form.notificationName }</b> foi cadastrada com sucesso`;
		},
		canNextStep() {
			if (this.form.notificationName && this.form.selectedChannelNames.length && this.form.contatos.length && this.form.selectedEmails.length && this.form.results.length && this.messageNameError == '') {
				return true;
			}
		}
	},
	async created() {
		await this.verifyPermissionUserAndInitiate();
	},
	mounted() {
		this.$root.$on('addCreatedSMTP', (serverSMTP) => {
			this.emails.push({
				name: serverSMTP.name,
				id: serverSMTP.id,
			})
			this.form.selectedEmails.push(serverSMTP.id)
		});
	},
	beforeDestroy() {
		this.$root.$off('addCreatedSMTP');
	},
	methods: {
		...mapActions('aliareAccount', ['listEmailsServerSMTP']),

		openModalEditServerSMTP(serverId) {
			this.$store.dispatch('ui/openModalWithData', { modalKey: SERVERS_SMTP_MODAL_KEY, data: { serverId }});
		},

		openModalEmail() {
			this.$store.dispatch('ui/openModalWithData', { modalKey: SERVERS_SMTP_MODAL_KEY, data: { serverId: '' }});
		},
		verifyResultSelected(result) {
			if (this.form.results.includes(result.toUpperCase())) return true;
		},
		toggleSelectResult(result) {
			if (this.verifyResultSelected(result)) {
				removeItemFromArrayByValue(this.form.results, result.toUpperCase())
			} else {
				this.form.results.push(result.toUpperCase());
			}
		},
		addWorkflowList(workflowIds) {
			this.form.aplicacao.push(...workflowIds);
		},

        removeKeyToForm(key) {
			if (this.verifyKeyAdded(key)) {
				removeItemFromArrayByValue(this.form.contatos, key);
			}
		},
		goToNotifications() {
			this.$router.push({
				name: 'notificationList',
			}).catch(()=>{});

			this.showNotification = false;
			this.showAlert = false;
		},
		goToCreateNotification() {
			window.location.reload();
			this.showNotification = false;
		},
		verifyKeyAdded(key) {
			return this.form.contatos.find(keyName => keyName === key);
		},
        toggleChannel(item) {
            const index = this.form.selectedChannelNames.indexOf(item);

            if (index > -1) {
                this.form.selectedChannelNames.splice(index, 1);
            } else {
                this.form.selectedChannelNames.push(item);
            }
        },
		toggleEmail(email){
			const index = this.form.selectedEmails.indexOf(email);

			if (index > -1) {
				this.form.selectedEmails.splice(index, 1);
			} else {
				this.form.selectedEmails = [];
				this.form.selectedEmails.push(email);
			}
		},
        addKeyToForm() {
            if (this.tempKey == '') return;

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (emailRegex.test(this.tempKey)) {
                this.form.contatos.push(JSON.parse(JSON.stringify(this.tempKey)));
                this.tempKey = '';
            }
		},

        resetInput(input) {
			switch (input) {
				case 'email':
					this.showEmailOptions = false;
					this.emailSearch = '';
					
					break;
				case 'channel':
					this.showChannelOptions = false;
					this.channelSearch = '';
					
					break;
			}
		},
				
		async verifyNameNotification() {
			if(this.form.notificationName != '' && this.form.notificationName != this.originalNotificationName) {

				this.messageNameSuccess = 'O nome da notificação está disponível para uso';
				this.messageNameError = '';

				await this.restApi().verifyNameAvailableNotification(this.form.notificationName).then((response) => {
					if (!response) {
						this.messageNameSuccess = 'O nome da notificação está disponível para uso';
						this.messageNameError = '';
					} else {
						this.messageNameError = 'O nome da notificação já está em uso';
						this.messageNameSuccess = '';
					}
				});
			} else {
				this.messageNameSuccess = '';
				this.messageNameError = '';
			}
		},

		changeStep(step) {
			this.currentStep = step;
		},
		async loadWorkspacesTreeView() {
			this.isLoadingSecondPage = true;
			try {
				this.listWorkspace = await this.restApi().getWorkflowsTreeView();
			} catch (error) {
				this.$store.commit('activeAlert', {
					message: error.response?.data?.notifications || error?.notifications[0],
					status: 'error',
				});
			} finally {
				this.isLoadingSecondPage = false;
			}
		},
		async editNotification() {
			this.$root.$emit('sendDataWorkflow');

			this.isLoadingSecondPage = true;
			try {
				const payload = {
					nome: this.form.notificationName,
					canal: this.form.selectedChannelNames[0], // Por Enquanto aceita apenas um canal
					contatos: this.form.contatos,
					informacoes: this.form.description,
					resultados: this.form.results,
					workflowsId: this.form.aplicacao || [],
					emailProviderId: this.form.selectedEmails[0] || '',
				}

				const response = await this.restApi().editNotificationById(this.$route.params.id, payload).then(() => {
					this.showNotification = true;
				})

			} catch (error) {
				this.$store.commit('activeAlert', {
					message: error?.notifications[0] || 'Ocorreu um erro ao editar a notificação. Tente novamente mais tarde.',
					status: 'error',
				});
			}
			this.isLoadingSecondPage = false;
		},

		async createNotification() {
			this.$root.$emit('sendDataWorkflow');

			this.isLoadingSecondPage = true;
			try {
				const payload = {
					nome: this.form.notificationName,
					canal: this.form.selectedChannelNames[0], // Por Enquanto aceita apenas um canal
					contatos: this.form.contatos,
					informacoes: this.form.description,
					resultados: this.form.results,
					workflowsId: this.form.aplicacao,
					emailProviderId: this.form.selectedEmails[0] || '',
				}

				const response = await this.restApi().createNewNotification(payload).then(() => {
					this.showNotification = true;
				})

			} catch (error) {
				this.$store.commit('activeAlert', {
					message: error?.notifications[0] || 'Ocorreu um erro ao cadastrar a notificação. Tente novamente mais tarde.',
					status: 'error',
				});
			}
			this.isLoadingSecondPage = false;
		},
		async verifyPermissionUserAndInitiate() {
			await this.validationAcessNotification().then(async () => {
				if (this.isEdit ? this.canEditNotification() : this.manageNotification) {
					await this.loadPageCreateEditNotification();
				} else {
					this.$store.commit('setData403', {show: true, prevPage: previousRoute});
				}
			});
		},
		async loadCurrentNotification() {
			this.isLoadingPage = true;
			try {
				const notificationId = this.$route.params.id;
				await this.loadServersEmail();
				const response = await this.restApi().getNotificationById(notificationId);
				const notification = response;
				this.form.notificationName = notification.nome;
				this.originalNotificationName = notification.nome;
				this.form.selectedChannelNames.push(notification.canal);
				this.form.contatos = notification.contatos;
				this.form.description = notification.informacoes;
				this.form.results = notification.resultados.map(str =>
					str
						.normalize("NFD")                
						.replace(/[\u0300-\u036f]/g, "") 
						.toUpperCase()                   
						.replace(/\s+/g, "_")
				);
				if (this.emailsFiltered.find((email) => email.id == notification.emailProviderId)) {
					this.form.selectedEmails.push(notification.emailProviderId);
				}
				this.prevSelectedWorkflows.push(...notification.workflows.map(workflow => workflow.id));
			} catch (error) {
				console.error(error);
				this.$store.commit('activeAlert', {
					message: 'Ocorreu um erro ao carregar a notificação. Tente novamente mais tarde.',
					status: 'error',
				});
				this.$router.push({
					name: 'notificationList',
				});

			}
			this.isLoadingPage = false;
		},
		async loadServersEmail() {
			const { data } = await this.listEmailsServerSMTP({tenantId: WebStorage.getItem('tenantId')});
			this.emails = data.map(email => ({
				name: email.name,
				id: email.id,
			}))
		},
		async loadPageCreateEditNotification() {

			if (this.isEdit) {
				await this.loadCurrentNotification();
			} else {
				this.isLoadingPage = false;
				await this.loadServersEmail();
			}
			await this.loadWorkspacesTreeView();
		},
	},
});
